var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mc_symbol 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6685 3.57031H8.32812V11.4323H12.6685V3.57031Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.59996 7.49999C8.59927 6.74283 8.76949 5.99543 9.09773 5.31437C9.42597 4.63332 9.90363 4.03647 10.4945 3.569C9.76278 2.98923 8.88395 2.62868 7.95851 2.52856C7.03307 2.42844 6.09836 2.59278 5.2612 3.00282C4.42404 3.41285 3.71822 4.05203 3.22442 4.84729C2.73061 5.64255 2.46875 6.56181 2.46875 7.49999C2.46875 8.43818 2.73061 9.35743 3.22442 10.1527C3.71822 10.948 4.42404 11.5871 5.2612 11.9972C6.09836 12.4072 7.03307 12.5715 7.95851 12.4714C8.88395 12.3713 9.76278 12.0108 10.4945 11.431C9.90363 10.9635 9.42598 10.3667 9.09774 9.68561C8.7695 9.00455 8.59928 8.25716 8.59996 7.49999Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.5177 7.49999C18.5178 8.43816 18.2559 9.35741 17.7622 10.1527C17.2684 10.9479 16.5626 11.5871 15.7254 11.9972C14.8883 12.4072 13.9536 12.5715 13.0282 12.4714C12.1027 12.3713 11.2239 12.0108 10.4922 11.431C11.0826 10.963 11.5599 10.3661 11.888 9.68515C12.2162 9.0042 12.3868 8.25704 12.3868 7.49999C12.3868 6.74295 12.2162 5.99578 11.888 5.31483C11.5599 4.63389 11.0826 4.03694 10.4922 3.569C11.2239 2.98923 12.1027 2.62867 13.0282 2.52856C13.9536 2.42844 14.8883 2.59279 15.7254 3.00283C16.5626 3.41287 17.2684 4.05204 17.7622 4.84731C18.2559 5.64257 18.5178 6.56182 18.5177 7.49999Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.0449 10.6003V10.4394H18.1093V10.4066H17.9453V10.4394H18.0097V10.6003H18.0449ZM18.3633 10.6003V10.4062H18.313L18.2552 10.5397L18.1974 10.4062H18.1471V10.6003H18.1826V10.4539L18.2368 10.5801H18.2736L18.3278 10.4536V10.6003H18.3633Z",
    fill: "#F79E1B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.d6e2057e0641f00db78b6db8513eb390.svg";
export { ForwardRef as ReactComponent };